module.exports = __webpack_public_path__ + "static/scale-model-of-classic-biplane-tours-in-louisville-kentucky-382565c42f6733289242245cf6b969de.png";